const popup = {
  trigersToggle: [

    {
      name: 'menu-mobile',
      open: [document.getElementById('jsOpenMenu')] as HTMLElement[],
      popup: document.getElementById('jsMenuWrap') as HTMLElement,
      close: document.getElementById('jsCloseMenu') as HTMLElement,
      overlay: true,
    },

    {
      name: 'menu-tablet',
      open: [document.getElementById('jsOpenShopTab')] as HTMLElement[],
      popup: document.getElementById('jsMenuWrap') as HTMLElement,
      close: document.getElementById('jsCloseMenu') as HTMLElement,
      overlay: true,
    },

    {
      name: 'menu-desktop',
      open: [document.getElementById('jsOpenShopDesk')] as HTMLElement[],
      popup: document.getElementById('jsMenuWrap') as HTMLElement,
      close: document.getElementById('jsCloseMenu') as HTMLElement,
      overlay: true,
    },

    {
      name: 'finder-tablet',
      open: [document.getElementById('jsFinderTab')] as HTMLElement[],
      popup: document.getElementById('jsMenuWrap') as HTMLElement,
      close: document.getElementById('jsCloseMenu') as HTMLElement,
      overlay: true,
    },

    {
      name: 'finder-desktop',
      open: [document.getElementById('jsFinderDesk')] as HTMLElement[],
      popup: document.getElementById('jsMenuWrap') as HTMLElement,
      close: document.getElementById('jsCloseMenu') as HTMLElement,
      overlay: true,
    },

      {
      name: 'search-mobile',
      open: [document.getElementById('jsOpenSearch')] as HTMLElement[],
      popup: document.getElementById('jsSearchWrap') as HTMLElement,
      close: document.getElementById('jsCloseSearch') as HTMLElement,
      overlay: true,
    },

    {
      name: 'search-tablet',
      open: [document.getElementById('jsSearchTablet')] as HTMLElement[],
      popup: document.getElementById('jsSearchWrap') as HTMLElement,
      close: document.getElementById('jsCloseSearch') as HTMLElement,
      overlay: true,
    },

    {
      name: 'search-desktop',
      open: [document.getElementById('jsSearchDesktop')] as HTMLElement[],
      popup: document.getElementById('jsSearchWrap') as HTMLElement,
      close: document.getElementById('jsCloseSearch') as HTMLElement,
      overlay: true,
    },


    {
      name: 'user-desktop',
      open: [document.getElementById('jsOpenDeskUser')] as HTMLElement[],
      popup: document.getElementById('jsUserWrap') as HTMLElement,
      close: document.getElementById('jsCloseUser') as HTMLElement,
      overlay: true,
    },

    {
      name: 'user-tablet',
      open: [document.getElementById('jsOpenTabletUser')] as HTMLElement[],
      popup: document.getElementById('jsUserWrap') as HTMLElement,
      close: document.getElementById('jsCloseUser') as HTMLElement,
      overlay: true,
    },

    {
      name: 'user-mobile',
      open: [document.getElementById('jsOpenMobUser')] as HTMLElement[],
      popup: document.getElementById('jsUserWrap') as HTMLElement,
      close: document.getElementById('jsCloseUser') as HTMLElement,
      overlay: true,
    },
    

    {
      name: 'mob-cart',
      open: [document.getElementById('jsOpenMobCart')] as HTMLElement[],
      popup: document.getElementById('jsCartWrap') as HTMLElement,
      close: document.getElementById('jsCloseCart') as HTMLElement,
      overlay: true,
    },

    {
      name: 'tablet-cart',
      open: [document.getElementById('jsOpenTabletCart')] as HTMLElement[],
      popup: document.getElementById('jsCartWrap') as HTMLElement,
      close: document.getElementById('jsCloseCart') as HTMLElement,
      overlay: true,
    },

    {
      name: 'desk-cart',
      open: [document.getElementById('jsOpenCartDesk')] as HTMLElement[],
      popup: document.getElementById('jsCartWrap') as HTMLElement,
      close: document.getElementById('jsCloseCart') as HTMLElement,
      overlay: true,
    },

      {
      name: 'filter',
      open: [document.getElementById('jsOpenFilter')] as HTMLElement[],
      popup: document.getElementById('jsFilterWrap') as HTMLElement,
      close: document.getElementById('jsCloseFilter') as HTMLElement,
      overlay: true,
    },


    {
      name: 'product-description',
      open: document.querySelectorAll('.jsDescriptionOpen') as NodeListOf<HTMLElement>,
      popup: document.getElementById('jsDescriptionWrap') as HTMLElement,
      close: document.getElementById('jsDescriptionClose') as HTMLElement,
      overlay: true,
    },

    {
      name: 'product-specs',
      open: document.querySelectorAll('.jsSpecsOpen') as NodeListOf<
        HTMLElement>,
      popup: document.getElementById('jsSpecWrap') as HTMLElement,
      close: document.getElementById('jsSpecClose') as HTMLElement,
      overlay: true,
    },

    {
      name: 'Enquiry',
      open: document.querySelectorAll('.jsEnquiryOpen') as NodeListOf<
        HTMLElement
      >,
      popup: document.getElementById('jsEnquiryWrap') as HTMLElement,
      close: document.getElementById('jsEnquiryClose') as HTMLElement,
      overlay: true,
    },

    
  ],

  overlay: document.getElementById('overlay')! as HTMLElement,
  close: document.querySelectorAll('.jsClose'),
  activClasse: [] as HTMLElement[],
  menuAdvert: document.getElementById('phoneAdvert'),

  init() {
    this.openPopupToggle()
    this.overlayClose()
  },

  overlayClose() {
    this.overlay.addEventListener('click', () => {
      this.overlay.classList.remove('activeClass')
      document.documentElement.style.overflow = 'auto'
      document.body.classList.remove('activeClass')
      this.closeAll()
    })
  },

  setOverlay(
    open: HTMLElement | boolean,
    popup: HTMLElement | null,
    triger: HTMLElement,
    overlay = false,
  ) {
    if (open && popup && triger) {
      this.closeAll()
      this.overlay.classList.remove('activeClass')
      if (overlay) {
        this.overlay.classList.add('activeClass')
      }

      document.documentElement.style.overflow = 'hidden'
      document.body.classList.add('activeClass')

      popup.classList.add('activeClass')
      triger.dataset.open = 'true'
      triger.classList.add('activeClass')
      this.activClasse.push(popup)
      this.activClasse.push(triger)
    } else {
      this.overlay.classList.remove('activeClass')
      triger.dataset.open = 'false'

      document.documentElement.style.overflow = 'auto'
      document.body.classList.remove('activeClass')

      this.closeAll()
    }
  },
  closeAll() {
    this.activClasse.forEach((item) => {
      item.classList.remove('activeClass')
      item.dataset.open = 'false'
    })
    this.activClasse = []
  },
  openPopupToggle() {
    this.trigersToggle.forEach((item, index) => {
      if (item['open'].length > 0) {
        item['open'].forEach((el) => {
         
          if (item['popup'] && el) {
            item['popup'].classList.add('init')
            el.addEventListener('click', (e) => {
              e.preventDefault()
              if (el.dataset.open === 'false') {
                this.setOverlay(true, item['popup'], el, item['overlay'])
              } else {
                this.setOverlay(false, item['popup'], el)
              }
            })
          }
        })

        if (item['close'] && typeof item['close'] === 'object') {
          item['close'].addEventListener('click', () => {
            item['open'].forEach((el: HTMLElement) => {
              this.setOverlay(false, item['popup'], el)
            })
          })
        }
      }
    })
  },
}

export default popup
